// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yWMK","clinicsSelect":"styles_clinicsSelect__1ezqQ"};